"use client";

import type React from "react";
import { cn } from "@/lib/utils";
import { LocaleSwitcher } from "../LocaleSwitcher";
import { NetworkMenu } from "../NetworkMenu/NetworkMenu";

export const SideNav: React.FC<{
  className?: string;
  initialPath?: string;
}> = ({ className, initialPath }) => (
  <aside
    className={cn(
      "hidden w-60 shrink-0 flex-col ps-5 pe-2 py-4 lg:flex sticky top-4 self-start",
      className,
    )}
  >
    <div className="flex max-h-[calc(100dvh-3rem)] flex-col gap-6 overflow-y-auto pe-1">
      <LocaleSwitcher />
      <NetworkMenu initialPath={initialPath} />
    </div>
  </aside>
);
